import { Button } from '../../../../../../components/Button'
import { type ExpertDomain } from '../../../../../../types/domain/expert-domain'

interface Props {
  data?: ExpertDomain
  edit: () => void
}

export const InternationalBankData = ({ data, edit }: Props) => {
  return (
    <div>
      <div>
        <p className="text-[#777777] mb-4">Dados bancários:</p>
        {data?.bankData && (
          <>
            <p>Swift Code: {data.bankData.swiftCode}</p>
            <p>Account Number/IBAN: {data.bankData.bankAccountNumber}</p>
            <p>Bank Branch Address: {data.bankData.internationalBankBranch}</p>
            <p>Amazon Gift Card Email: {data.bankData.amazonGiftCardEmail}</p>
          </>
        )}
      </div>

      <Button variant="outline" className="mt-10" onClick={edit}>
        Editar
      </Button>
    </div>
  )
}
